import { render } from "./NavBarr.vue?vue&type=template&id=32ba03b4"
import script from "./NavBarr.vue?vue&type=script&lang=js"
export * from "./NavBarr.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__